const operacoes = [
    {
        codigo: 1,
        nome: 'Adicionar titular',
        tipoTraducao: 'inclusaoTitular',
        path: '/adicionar_titular',
        draftFlow: 'adicionar_titular',
    },
    {
        codigo: 2,
        nome: 'Adicionar dependente',
        tipoTraducao: 'inclusaoDependente',
        path: '/adicionar_dependente',
        draftFlow: 'selecionar_titular',
    },
    { codigo: 3, nome: 'Alterar beneficiário', tipoTraducao: 'alteracaoCadastral', path: '/alterar_' },
    { codigo: 4, nome: 'Transferir beneficiário', tipoTraducao: 'transferir', path: '/transferencia_beneficiario' },
    { codigo: 5, nome: 'Trocar o plano', tipoTraducao: 'trocaPlano', path: '/trocar_plano' },
    { codigo: 6, nome: 'Reativação', tipoTraducao: 'reativacao', path: '/' },
    { codigo: 7, nome: 'Desligar beneficiário', tipoTraducao: 'desligar', path: '/desligar_beneficiario' },
    {
        codigo: 9,
        nome: 'Aposentados e demitidos',
        tipoTraducao: 'aposentadosDemitidos',
        path: '/preencher_dados_aposentados_demitidos',
        draftFlow: 'aposentados_demitidos',
    },
    // { codigo: 14, nome: 'Remissão', tipoTraducao: 'remissao', path: '/' },
];

const statusGroup = [
    { codigo: 2, nome: 'Rascunho', cor: '#0B7EB5' },
    { codigo: 3, nome: 'Em análise', cor: '#5B5B5F' },
    { codigo: 4, nome: 'Recusado', cor: '#EC130F' },
    { codigo: 5, nome: 'Em autorização', cor: '#EC130F' },
    { codigo: 6, nome: 'Enviado', cor: '#EC130F' },
    { codigo: 7, nome: 'Pendente Ajuste', cor: '#EC130F' },
];

const exportOptions = { operacoes, statusGroup };

export default exportOptions;
